import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import { loadAgentColors } from './components/colorFromId'
import { subscribe as subscribeAuth } from './auth'
import { applyStil, getStil } from './lib/stil'
import { oberflaecheAnwenden } from './lib/oberflaeche'

// Stil (V2/V3) und Sprache an <html>, bevor etwas gezeichnet wird (Post #5421).
applyStil(getStil())
oberflaecheAnwenden()

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
})

// Post #5048: Agentenfarben vor dem ersten Render laden, aber hoechstens
// 800 ms darauf warten; danach bei jedem Login/Logout neu.
subscribeAuth(() => { void loadAgentColors() })
await Promise.race([loadAgentColors(), new Promise((r) => setTimeout(r, 800))])

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
